/*
 * @Description: Do not edit
 * @Author: wangsx
 * @Date: 2021-03-23 17:38:23
 * @LastEditors: your name
 * @LastEditTime: 2022-01-05 14:58:16
 */
import router from "@/router";

import { createPermissionGuard } from "./permissionGuard";
createPermissionGuard(router);
